import { render, staticRenderFns } from "./P-ImageMap.vue?vue&type=template&id=399d505a&lang=pug&"
import script from "./P-ImageMap.vue?vue&type=script&lang=js&"
export * from "./P-ImageMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports